import script from "./TransactionConfirmOther.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionConfirmOther.vue?vue&type=script&setup=true&lang=js"

import "./TransactionConfirmOther.vue?vue&type=style&index=0&id=5b286afb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b286afb"]])

export default __exports__